{
  "name": "typesync",
  "version": "0.14.3",
  "type": "module",
  "description": "Install missing TypeScript typings for your dependencies.",
  "engines": {
    "node": "^18.20.0 || ^20.10.0 || >=22.0.0"
  },
  "files": [
    "dist",
    "bin"
  ],
  "bin": {
    "typesync": "./bin/typesync"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest --ui",
    "fix": "eslint --fix && npm run format",
    "lint": "eslint && tsc && npm run format:check",
    "format": "prettier --write 'src/**/*.ts'",
    "format:check": "prettier --check 'src/**/*.ts'",
    "lint:watch": "nodemon --exec npm run lint",
    "build": "tsdown",
    "build:watch": "tsdown --watch",
    "run-cli": "npm run build -- --silent && node bin/typesync",
    "run-cli:dry": "npm run run-cli -- --dry",
    "do:publish": "npm run lint && npm run test && npm run build && npm publish",
    "release:patch": "npm version patch && npm run do:publish && git push --follow-tags",
    "release:minor": "npm version minor && npm run do:publish && git push --follow-tags",
    "release:prerelease": "npm version prerelease && npm run do:publish && git push --follow-tags"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jeffijoe/typesync.git"
  },
  "author": "Jeff Hansen <jeff@jeffijoe.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jeffijoe/typesync/issues"
  },
  "homepage": "https://github.com/jeffijoe/typesync#readme",
  "dependencies": {
    "ansis": "^3.17.0",
    "awilix": "^12.0.5",
    "detect-indent": "^7.0.1",
    "lilconfig": "^3.1.3",
    "npm-registry-fetch": "^18.0.2",
    "picospinner": "^3.0.0",
    "semver": "^7.7.0",
    "tinyglobby": "^0.2.12",
    "yaml": "^2.7.1"
  },
  "devDependencies": {
    "@eslint/js": "^9.23.0",
    "@types/node": "^22.13.17",
    "@types/npm-registry-fetch": "^8.0.7 || ~18.0.0",
    "@types/semver": "~7.7.0",
    "@vitest/coverage-v8": "^3.1.1",
    "@vitest/ui": "^3.1.1",
    "eslint": "^9.23.0",
    "globals": "^16.0.0",
    "nodemon": "^3.1.9",
    "prettier": "^3.5.3",
    "publint": "^0.3.9",
    "tsdown": "^0.7.2",
    "typescript": "^5.8.2",
    "typescript-eslint": "^8.29.0",
    "unplugin-unused": "^0.4.4",
    "vitest": "^3.1.1"
  },
  "packageManager": "npm@10.8.2"
}
